import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import CreaTemaPropuesto from "./CrearTemaPropuesto";
import CreaFortaleza from "./CreaFortaleza";

function InfoFortaleza(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerRespuestasFichaTecnica/" +
        props.idSolicitud +
        "/2",
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const [datos, setDatos] = useState([]);
  useEffect(() => {
    // Esta función se ejecutará al cargar el componente y luego cada 5 segundos
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://suadesarrollo.azurewebsites.net/api/ObtenerRespuestasFichaTecnica/" +
            props.idSolicitud +
            "/2",
        );
        setDatos(response.data);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    const intervalId = setInterval(fetchData, 2000); // Llama a fetchData cada 5 segundos

    return () => clearInterval(intervalId); // Limpia el intervalo cuando el componente se desmonta
  }, []);
  return (
    <Fragment>
      <CreaFortaleza idSolicitud={props.idSolicitud} />
      <div className="text-justify">
        <div class="container-fluid">
          <div class="card shadow mb-4">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary"></h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table
                  class="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Tema</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datos.map((item) => {
                      return (
                        <tr>
                          <td>{item.id}</td>
                          <td>{item.respuesta}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default InfoFortaleza;
